module.exports = __webpack_public_path__ + "static/media/thank_you.2cf8367b.png";